import { c as _c } from "react/compiler-runtime";
import type { CollectedDataOption, DataIdentifier } from '@onefootprint/request-types/dashboard';
import { Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import BaseHoverCard from '../../../base-hover-card';
import FinancialData from '../../components/financial-data';
import FirstFieldsText from '../../components/first-fields';
import getFinancialData from '../../get-financial-data';
import useTranslateAndSortFields from '../hooks/use-translate-and-sort-fields';
const DEFAULT_NUM_VISIBLE_FIELDS = 3;
type FieldListProps = {
  fields: DataIdentifier[];
  cdos?: CollectedDataOption[];
  numVisibleFields?: number;
};
const FieldList = t0 => {
  const $ = _c(29);
  const {
    fields,
    cdos: t1,
    numVisibleFields: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const cdos = t3;
  const numVisibleFields = t2 === undefined ? DEFAULT_NUM_VISIBLE_FIELDS : t2;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      keyPrefix: "events.userData"
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const {
    t
  } = useTranslation("security-logs", t4);
  const isMobile = useMobileLayout();
  let t5;
  if ($[3] !== fields) {
    t5 = getFinancialData(fields);
    $[3] = fields;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const {
    cards,
    bankAccounts,
    nonFinancialFields,
    hasFinancialData
  } = t5;
  const allNonFinancialFields = useTranslateAndSortFields(nonFinancialFields, cdos);
  let t6;
  if ($[5] !== allNonFinancialFields || $[6] !== numVisibleFields) {
    t6 = allNonFinancialFields.slice(0, numVisibleFields);
    $[5] = allNonFinancialFields;
    $[6] = numVisibleFields;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const visibleFields = t6;
  let t7;
  if ($[8] !== allNonFinancialFields || $[9] !== numVisibleFields) {
    t7 = allNonFinancialFields.slice(numVisibleFields);
    $[8] = allNonFinancialFields;
    $[9] = numVisibleFields;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const collapsedFields = t7;
  const CollapsedFields = _temp2;
  let t8;
  if ($[11] !== collapsedFields || $[12] !== isMobile || $[13] !== t) {
    t8 = () => {
      if (!collapsedFields.length) {
        return null;
      }
      if (isMobile) {
        const label = `${collapsedFields.length} ${collapsedFields.length === 1 ? t(_temp3) : t(_temp4)}`;
        return <BaseHoverCard textTrigger={label} titleText={label}><CollapsedFields collapsedFields={collapsedFields} /></BaseHoverCard>;
      }
      return <Tooltip disabled={!collapsedFields.length} content={<CollapsedFields collapsedFields={collapsedFields} />}><p className="underline cursor-default text-label-2">{collapsedFields.length} {collapsedFields.length === 1 ? t(_temp5) : t(_temp6)}</p></Tooltip>;
    };
    $[11] = collapsedFields;
    $[12] = isMobile;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const renderCollapsedFields = t8;
  let t9;
  if ($[15] !== bankAccounts || $[16] !== cards || $[17] !== hasFinancialData || $[18] !== visibleFields) {
    t9 = hasFinancialData && <FinancialData cards={cards} bankAccounts={bankAccounts} hasNonFinancialFields={!!visibleFields.length} />;
    $[15] = bankAccounts;
    $[16] = cards;
    $[17] = hasFinancialData;
    $[18] = visibleFields;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = collapsedFields.length > 0;
  let t11;
  if ($[20] !== t10 || $[21] !== visibleFields) {
    t11 = <FirstFieldsText fields={visibleFields} hasCollapsedFields={t10} />;
    $[20] = t10;
    $[21] = visibleFields;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== renderCollapsedFields) {
    t12 = renderCollapsedFields();
    $[23] = renderCollapsedFields;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t9) {
    t13 = <>{t9}{t11}{t12}</>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
export default FieldList;
function _temp(field) {
  return <li key={field}>{field.startsWith("di.") || field.includes(".") ? <span className="text-snippet-3">{field}</span> : field}</li>;
}
function _temp2(t0) {
  const {
    collapsedFields: collapsedFields_0
  } = t0;
  return <ul className="flex flex-col py-1 pl-4 list-disc">{collapsedFields_0.map(_temp)}</ul>;
}
function _temp3($) {
  return $.otherAttribute;
}
function _temp4($_0) {
  return $_0.otherAttributes;
}
function _temp5($_1) {
  return $_1.otherAttribute;
}
function _temp6($_2) {
  return $_2.otherAttributes;
}